module.exports = __webpack_public_path__ + "img/louyou_checked.3cd8c283.png";